import React from 'react';
import './index.less';
import Row from './row';

function PayoutTable({ table, ...props }) {
	const { rows, headers, columns, rowsKeys, offerSaleModelsMapping } = table;
	return (
		<div
			className="table-container payout-requests-matrix-table"
		>
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium">
					<tr className="top-affiliates-table-top-row">
						{
							headers
								.map((header, i) =>
									<th key={i} className={header.className || ''}>{header.title}</th>
								)
						}
						{
							columns
								.map((col, i) =>
									<th key={i} className={(col.is_new_country && 'is_new_country') + ' text-center'}>{col.title}</th>
								)
						}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{rowsKeys.map((row, index) =>
						row.main_sale_model
							? <Row
								row={row} key={index} {...props} columns={columns} rows={rows}
								offerSaleModelsMapping={offerSaleModelsMapping}
							/>
							: <tr className="spacing-row">
								{
									headers
										.map((header, i) =>
											<td key={i} className={''}>{}</td>
										)
								}
								{
									columns
										.map((header, i) =>
											<td key={i} className={''}>{}</td>
										)
								}
							</tr>
					)}
				</tbody>
			</table>
		</div>
	);
}

export default PayoutTable;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-payout-matrix/main.js